/**
 * Loại tờ khai
 */
export default {
  VATFirst: 0,
  VATAdditional: 1,
};
